import { Vector3 } from "three";
import { AudioController, Sfx } from "../../../../AudioController";
import { Vegetable } from "../../Vegetable";
import { BaseMole } from "../BaseMole";
import { MoleAnimationController, MoleAnimationState } from "../MoleAnimationController";
import { DieState } from "./DieState";
import { FreezeState } from "./FreezeState";
import { IMoleState } from "./IMoleState";
import { DigInState } from "./DigInState";

export class EatingState implements IMoleState {
    private nextState: IMoleState;
    private eatingInProgress: boolean;

    public constructor(
        private readonly mole: BaseMole,
        private readonly animationController: MoleAnimationController,
        private readonly afterEatingState: IMoleState,
        private readonly digInState: DigInState,
        private readonly dieState: DieState,
        private readonly freezeState: FreezeState,
        private readonly vegetable: Vegetable,
        private readonly audioController: AudioController
    ) {
        this.eatingInProgress = false;
    }

    public enter(previousState: IMoleState): void {
        if (!this.vegetable.alive) {
            this.nextState = this.digInState;
            return;
        }
        this.animationController.onClipEnd.add(this.handleClipEnd, this);
        this.animationController.onAnimationProgress.add(this.waitForCorrectEatFrame, this);
        if (!(previousState instanceof FreezeState)) {
            this.nextState = this;
            this.animationController.transitToState(MoleAnimationState.Bites);
        }
        this.mole.lookAt(this.vegetable.getWorldPosition(new Vector3()));
        this.mole.onCanBeDestroyed.add(this.cancel, this);
    }

    private async handleClipEnd(_state: MoleAnimationState): Promise<void> {
        this.nextState = this.afterEatingState;
        this.eatingInProgress = false;
    }

    private waitForCorrectEatFrame(state: MoleAnimationState, progress: number): void {
        if (state != MoleAnimationState.Bites || this.eatingInProgress) {
            return;
        }
        if (progress > 0.4) {
            this.eatingInProgress = true;
            this.eat();
        }
    }

    private eat(): void {
        if (this.vegetable == null) {
            console.warn("Mole try to eat, but vegetable is null!");
            return;
        }
        this.audioController.playSfx(Sfx.Eating);
        this.vegetable.takeDamage(50);
    }

    public exit(): void {
        this.mole.onCanBeDestroyed.remove(this.cancel, this);
        this.animationController.onClipEnd.remove(this.handleClipEnd, this);
        this.animationController.onAnimationProgress.remove(this.waitForCorrectEatFrame, this);
        this.mole.lookAtCharacter();
    }

    public process(_dt: number): IMoleState {
        if (!this.mole.alive) {
            return this.dieState;
        }
        if (this.mole.freezed) {
            return this.freezeState;
        }
        return this.nextState;
    }

    private cancel(): void {
        this.animationController.onAnimationProgress.remove(this.waitForCorrectEatFrame, this);
    }

}